module.exports = __webpack_public_path__ + "static/media/icon-no-number.6beb7678.svg";